import { autoinject, transient, computedFrom, useView } from "aurelia-framework";
import { ChildComponent } from "../../../child-component";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import {
    VoyageDataSubmissionStatusEnum, VoyageDataSubmissionClientModel
} from "../../../../../../models/vetting/vetting.models";
import { LookupValue, LookupValueRequest } from "../../../../../../models/lookups/lookup.models";
import { LookupValueQuery } from "../../../../../../constants/modules/lookup.constants";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject
@transient()
@useView('views/pages/modules/voyage-data-submission/steps/overview/voyage-data-submission-overview.html')
export class VoyageDataSubmissionOverview extends ChildComponent<VoyageDataSubmissionClientModel> {

    private voyageDataSubmissionStatuses: LookupValue[];
    public isRightShipUser: boolean;
    public isShowMoreSectionStatus: boolean;
    public viewCorrespondence: any;
    public reassignment: VoyageDataSubmissionStatusEnum = VoyageDataSubmissionStatusEnum.VoyageDataSubmissionReassignment;
    public reloadItemFunc: any;
    public canViewVoyageDataSubmissionDocuments: boolean;
    public canContactRightshipOperations: boolean;

    showMoreSectionStatus() {
        this.isShowMoreSectionStatus = !this.isShowMoreSectionStatus;
    }

    @computedFrom("item", "item.voyageDataSubmissionStatusId")
    get completed() {
        return this.item && (this.item.voyageDataSubmissionStatusId == VoyageDataSubmissionStatusEnum.ReadyForReporting || this.item.voyageDataSubmissionStatusId == VoyageDataSubmissionStatusEnum.Completed || this.item.voyageDataSubmissionStatusId == VoyageDataSubmissionStatusEnum.Cancelled);
    }

    get awaitingResponse() {
        return this.item && (this.item.voyageDataSubmissionStatusId == VoyageDataSubmissionStatusEnum.AwaitingResponse);
    }

    @computedFrom(Reflection.getPropertyPath<VoyageDataSubmissionOverview>(z => z.voyageDataSubmissionStatuses),
    Reflection.getPropertyPath<VoyageDataSubmissionOverview>(z => z.voyageDataSubmissionStatuses.length),
        Reflection.getPropertyPath<VoyageDataSubmissionOverview>(z => z.item),
        Reflection.getPropertyPath<VoyageDataSubmissionOverview>(z => z.item.voyageDataSubmissionStatusId))
    get voyageDataSubmissionStatus() {
        if (this.voyageDataSubmissionStatuses && this.item)
            return this.voyageDataSubmissionStatuses.filter(x => x.id == this.item.voyageDataSubmissionStatusId)[0];

        return null;
    }

    @computedFrom("item", "item.voyageDataSubmissionStatusHistory", "item.voyageDataSubmissionStatusHistory.length", "item.voyageDataSubmissionStatusId")
    get lastVoyageDataSubmissionStatusHistory() {
        return this.item.voyageDataSubmissionStatusHistory[0];
    }

    @computedFrom("item", "item.voyageDataSubmissionStatusId")
    get notNewOrProcessing() {
        return this.item && this.item.voyageDataSubmissionStatusId != VoyageDataSubmissionStatusEnum.Draft && this.item.voyageDataSubmissionStatusId != VoyageDataSubmissionStatusEnum.Submitted;
    }

    @computedFrom("item", "item.voyageDataSubmissionStatusId")
    get shouldShowContactRS() {

        let statuses = [];

        if (this.canContactRightshipOperations) {
            statuses = [VoyageDataSubmissionStatusEnum.Submitted,
                VoyageDataSubmissionStatusEnum.InProgress,
                VoyageDataSubmissionStatusEnum.AwaitingResponse,
                VoyageDataSubmissionStatusEnum.ReviewRequired,
                VoyageDataSubmissionStatusEnum.VoyageDataSubmissionReassignment];
        }

        if (this.userClaimsService.hasPermission(Claims.CanContactRsOperationsWhenCarbonAccountingHasOutcome)) {
            statuses.push(VoyageDataSubmissionStatusEnum.ReadyForReporting);
            statuses.push(VoyageDataSubmissionStatusEnum.Cancelled);
        }

        return this.item && statuses.indexOf(this.item.voyageDataSubmissionStatusId) > -1;
    }

    constructor(
        notificationsService: NotificationClientService, lookupClientService: LookupClientService,
        private userClaimsService: UserClaimsService, i18N: I18N, private dialogClientService: DialogClientService
    ) { 
        super(notificationsService, i18N);
        const request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.VoyageDataSubmissionStatuses;
        lookupClientService.getLookup(request).then(x => {
            this.voyageDataSubmissionStatuses = x.activeValues;
        });
        this.isRightShipUser = this.userClaimsService.hasPermission(Claims.RightShipUser);
        this.canViewVoyageDataSubmissionDocuments = this.userClaimsService.hasPermission(Claims.CanViewCarbonAccountingDocuments);
    }

    @computedFrom("lastVoyageDataSubmissionStatusHistory", "lastVoyageDataSubmissionStatusHistory.user")
    get lastVoyageDataSubmissionStatusHistoryUser() {
        const systemStatuses = [
            VoyageDataSubmissionStatusEnum.Draft,
            VoyageDataSubmissionStatusEnum.Submitted,
            VoyageDataSubmissionStatusEnum.ReviewRequired
        ];
        let user = this.lastVoyageDataSubmissionStatusHistory.user;
        if (!user && (systemStatuses.indexOf(this.lastVoyageDataSubmissionStatusHistory.statusId) > -1)) user = "System";
        return user;
    }

    navigateToDocumentsTabFunc:any;

    navigateToDocumentsTab() {
        if (this.canViewVoyageDataSubmissionDocuments)
            this.navigateToDocumentsTabFunc();
    }
    
    showContactVoyageDataSubmissionSuperDialog() {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AddCorrespondenceDialog, {
            entityId: this.item.voyageDataSubmissionId,
            entityTypeId: EntityTypes.VoyageDataSubmission
        }, true, false, false, "right");
    }
}
